import React from 'react'
import GlobalVibrancyRankingChart from '../Chart/GlobalVibrancyRankingChart/GlobalVibrancyRankingChart'
import { useAppSelector } from 'hooks'
import { viewType } from 'store/vibrancy/reducerSlice'
import Table from '../Chart/TableChart'
import NationalVibrancyRankingChart from '../Chart/NationalVibrancyRankingChart/NationalVibrancyRankingChart'
import { ranking } from 'store/AIMetricOT/reducerSlice'
import SlopeChart from '../Chart/SlopeChart/SlopeChart'
import SubIndexRankingChart from 'components/SubIndices/SubIndexRankingChart'

export default function GlobalNationalVibrancyRanking() {
  const currentViewType = useAppSelector(viewType)
  const currentRanking = useAppSelector(ranking)

  return (
    <>
      {currentViewType === 'bar' && currentRanking === 'global' && <GlobalVibrancyRankingChart />}
      {currentViewType === 'bar' && currentRanking === 'national' && <NationalVibrancyRankingChart />}
      {currentViewType === 'bar' && currentRanking === 'subindices' && <SubIndexRankingChart />}
      {currentViewType === 'table' && <Table />}
      {currentViewType === 'slope' && <SlopeChart />}
    </>
  )
}
